import styled from "styled-components";
import { theme } from "theme";

export const LayoutForm = styled.div`
  padding: ${theme.spacing(3)};
  max-width: 600px;
  margin: 0 auto;
  background: linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[50]} 100%);
  border-radius: ${theme.shape.borderRadius * 2}px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid ${theme.palette.grey[200]};
  
  @media (max-width: 768px) {
    padding: ${theme.spacing(2)};
    margin: ${theme.spacing(1)};
    border-radius: ${theme.shape.borderRadius}px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  .MuiFormControl-root {
    margin-bottom: ${theme.spacing(4)};
    width: 100%;
    
    @media (max-width: 768px) {
      margin-bottom: ${theme.spacing(3)};
    }
  }

  .form-fields {
    display: flex;
    gap: ${theme.spacing(3)};
    flex-direction: column;
    margin-bottom: ${theme.spacing(4)};
    
    @media (max-width: 768px) {
      gap: ${theme.spacing(2)};
      margin-bottom: ${theme.spacing(3)};
    }
  }

  .page-title {
    color: ${theme.palette.text.primary};
    font-weight: 600;
    margin-bottom: ${theme.spacing(4)} !important;
    text-align: center;
    
    @media (max-width: 768px) {
      font-size: 1.5rem !important;
      margin-bottom: ${theme.spacing(3)} !important;
    }
  }

  .submit-button {
    width: 100%;
    padding: ${theme.spacing(2)} !important;
    font-size: 1rem !important;
    font-weight: 600 !important;
    border-radius: ${theme.shape.borderRadius}px !important;
    text-transform: none !important;
    background: linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    transition: all 0.2s ease-in-out !important;
    
    &:hover {
      transform: translateY(-2px) !important;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
    }
    
    @media (max-width: 768px) {
      padding: ${theme.spacing(1.5)} !important;
      font-size: 0.95rem !important;
    }
  }
`;
